import React from 'react';
import { TFunction } from 'i18next';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ContextMenuButton, NameEmailAvatar } from '../../../../ui';
import { ADMIN_PAGES_KEYS } from '../../../../i18n/constants/keys';
import { EmployeeUser } from '../../../../utils/types/admin_types';

// Tooltip component for displaying truncated text with an accessible MUI tooltip
const TooltipWrapper: React.FC<{ text?: string | null }> = ({ text }) => {
  const displayText = text || '-';
  return (
    <Tooltip title={displayText} arrow placement='top'>
      <Typography
        sx={{
          maxWidth: 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: '0.8125rem',
          color: 'text.secondary',
          cursor: 'default',
        }}
      >
        {displayText}
      </Typography>
    </Tooltip>
  );
};

interface GetColumnsArgs {
  handleOpenMenu: (
    e: React.MouseEvent<HTMLButtonElement>,
    row: EmployeeUser,
  ) => void;
  handleCloseMenu: () => void;
  anchorEl: HTMLElement | null;
  t: TFunction;
}

export const getColumns = ({
  handleOpenMenu,
  handleCloseMenu,
  anchorEl,
  t,
}: GetColumnsArgs) => {
  const EM = ADMIN_PAGES_KEYS.employeeManagement;
  return [
    {
      key: 'Name',
      label: t(EM.columns.user),
      width: '250px',
      align: 'left' as const,
      render: (row: EmployeeUser) => (
        <NameEmailAvatar
          email={row.user?.email}
          name={`${row.user?.firstName || ''} ${row.user?.lastName || ''}`.trim()}
          avatar={row.user?.profilePic}
        />
      ),
      disableSort: true,
    },
    {
      key: 'Groups',
      label: t(EM.columns.groups),
      width: '250px',
      align: 'left' as const,
      render: (row: EmployeeUser) => (
        <TooltipWrapper
          text={row.groups?.map((group) => group.groupName).join(', ')}
        />
      ),
      disableSort: true,
    },
    {
      key: 'Last Active',
      label: t(EM.columns.lastActive),
      width: '250px',
      align: 'left' as const,
      render: (row: EmployeeUser) => (
        <TooltipWrapper
          text={
            row.lastActive
              ? new Date(row.lastActive * 1000).toLocaleString()
              : '-'
          }
        />
      ),
      disableSort: true,
    },
    {
      key: 'Actions',
      label: '',
      width: '100px',
      align: 'right' as const,
      render: (row: EmployeeUser) => (
        <ContextMenuButton
          row={row}
          onOpenMenu={(e, r) => handleOpenMenu(e, r as EmployeeUser)}
          onCloseMenu={handleCloseMenu}
          anchorEl={anchorEl}
        />
      ),
      disableSort: true,
    },
  ];
};
